'use strict';
import SearchContext from '../../siteSearch/enums/SearchContext';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
import BlockEntryType from '../enums/BlockEntryType';
import SuggestionBlock from '../ui/SuggestionBlock';
import { SEARCH_BASE, ECOM_SEARCH_BASE, ECOM_DEV_SEARCH_BASE } from '../../siteSearch/api/ApiConfig';
var createEmptyBlock = function (context, source) { return new SuggestionBlock({
    type: source.type,
    data: []
}, source.layout, [], source.categoryStyle, context.pluginConfiguration.suggestions, source.style); };
var generateId = function (type) { return "".concat(type, "_").concat(Math.round(Math.random() * 100000)); };
var searchApiResponseToDataSet = function (data) {
    if (data !== undefined && data.suggests === undefined && data.searchResults !== undefined) { // product search fallback
        data.suggests = data.searchResults.reduce(function (acc, entry) {
            acc[entry.name] = entry.results || [];
            return acc;
        }, {});
    }
    return Object.keys(data.suggests).reduce(function (acc, key) {
        data.suggests[key].forEach(function (entry) {
            var firstEntry;
            if (entry instanceof Array) {
                firstEntry = entry[0];
            }
            else {
                firstEntry = entry;
            }
            var image = firstEntry.image;
            var minifiedImage = (firstEntry.images || []).filter(function (otherImage) { return otherImage.url === image && (otherImage.minSuggestUrl || '').length > 0; })[0];
            if (minifiedImage !== undefined) {
                image = minifiedImage.minSuggestUrl;
            }
            if (firstEntry.type === 'HTML' && firstEntry.resultSet !== undefined && firstEntry.name === undefined) {
                return acc;
            }
            acc.push({
                image: image,
                title: firstEntry.name,
                link: firstEntry.link,
                snippet: firstEntry.content,
                contentGroup: key,
                id: generateId('resultGroup'),
                dataPoints: firstEntry.dataPoints,
                identifier: firstEntry.identifier,
                suggestionHtml: firstEntry.suggestionHtml
            });
        });
        return acc;
    }, []);
};
var loadResultGroup = function (context, suggestionUrl, query, source, callback, skipQuerySuggestions, includeContentGroups, excludeContentGroups, ignoreSettings) {
    if (skipQuerySuggestions === void 0) { skipQuerySuggestions = false; }
    if (ignoreSettings === void 0) { ignoreSettings = false; }
    if (source.query !== undefined) {
        query = source.query;
    }
    if (!ignoreSettings) {
        var exclude = [];
        var include = [];
        var maxQuerySuggestions = 0;
        var ignoreOther = false;
        if (source.value !== undefined && source.value.length > 0) {
            include.push(source.value);
        }
        else if (includeContentGroups !== undefined || excludeContentGroups !== undefined) {
            include = includeContentGroups;
            exclude = excludeContentGroups;
        }
        else {
            var contentGroups = context.pluginConfiguration.contentGroups;
            exclude = contentGroups.exclude;
            include = contentGroups.include;
            ignoreOther = contentGroups.ignoreOther;
            var maxSuggestions_1 = context.pluginConfiguration.suggestions.maxSuggestions;
            if (Object.keys(maxSuggestions_1).length > 0) {
                include = Object.keys(maxSuggestions_1).map(function (key) { return "".concat(key, "#").concat(maxSuggestions_1[key]); });
            }
            maxQuerySuggestions = context.pluginConfiguration.suggestions.maxQuerySuggestions;
        }
        if (skipQuerySuggestions) {
            maxQuerySuggestions = 0;
            exclude = exclude || [];
            exclude.push('ss360QuerySuggestions');
        }
        if (include !== undefined) {
            suggestionUrl += "&includeContentGroups=".concat(encodeURIComponent(JSON.stringify(include)));
        }
        if (exclude !== undefined || ignoreOther) {
            if (exclude === undefined) {
                exclude = [];
            }
            if (ignoreOther && exclude.indexOf('_') === -1) {
                exclude.push('_');
            }
            suggestionUrl += "&excludeContentGroups=".concat(encodeURIComponent(JSON.stringify(exclude)));
        }
        if (maxQuerySuggestions > 0 || skipQuerySuggestions) {
            suggestionUrl += "&maxQuerySuggestions=".concat(maxQuerySuggestions);
        }
        if (context.pluginConfiguration.catalogId !== undefined) {
            suggestionUrl = "".concat(suggestionUrl, "&catalogId=").concat(encodeURIComponent(context.pluginConfiguration.catalogId));
        }
        if (context.pluginConfiguration.userGroup !== undefined) {
            suggestionUrl = "".concat(suggestionUrl, "&userGroup=").concat(encodeURIComponent(context.pluginConfiguration.userGroup));
        }
        if (context.pluginConfiguration.suggestions.filters !== undefined) {
            suggestionUrl = "".concat(suggestionUrl, "&filters=").concat(encodeURIComponent(JSON.stringify(context.pluginConfiguration.suggestions.filters)));
        }
    }
    var num = source.limit !== undefined ? source.limit : context.pluginConfiguration.suggestions.num;
    if (num !== null) {
        suggestionUrl = "".concat(suggestionUrl, "&limit=").concat(num);
        if (source.value === 'ss360QuerySuggestions' || source.type === BlockEntryType.PopularQueries) {
            suggestionUrl = "".concat(suggestionUrl, "&maxQuerySuggestions=").concat(num);
        }
    }
    suggestionUrl = "".concat(suggestionUrl, "&site=").concat(context.pluginConfiguration.siteId);
    SxQueryUtils.get("".concat(suggestionUrl, "&query=").concat(encodeURIComponent(query)), function (data) {
        callback(new SuggestionBlock({
            type: source.type,
            data: searchApiResponseToDataSet(data),
            plan: data.plan,
            attribution: data.attribution
        }, source.layout, source.dataPoints, source.categoryStyle, context.pluginConfiguration.suggestions, source.style, data.interpretedQuery));
    }, function () {
        callback(createEmptyBlock(context, source));
    }, 'json', false);
};
var loadPopularQueries = function (context, suggestionUrl, source, callback) {
    loadResultGroup(context, suggestionUrl, '', source, callback, false, [], [], true);
};
var loadSearchHistory = function (context, source, callback) {
    // @ts-ignore
    var data = context.readObject('unibox_search_history', []).map(function (entry) { return ({
        title: entry,
        id: generateId('history')
    }); }).slice(0, source.limit || context.pluginConfiguration.suggestions.maxSearchHistoryEntries);
    callback(new SuggestionBlock({
        type: source.type,
        data: data
    }, source.layout, source.dataPoints, source.categoryStyle, context.pluginConfiguration.suggestions, source.style));
};
var loadDataSet = function (context, source, callback) {
    callback(new SuggestionBlock({
        type: source.type,
        data: source.content || []
    }, source.layout, source.dataPoints, source.categoryStyle, context.pluginConfiguration.suggestions, source.style));
};
var loadPopularResults = function (context, source, callback) {
    var baseUrl = SEARCH_BASE;
    var _a = context.pluginConfiguration, siteId = _a.siteId, ecom = _a.ecom, ecomDev = _a.ecomDev;
    var endpoint = ecom || ecomDev ? '/search/top-products' : '/sites/suggest/popularResults';
    if (ecom) {
        baseUrl = ECOM_SEARCH_BASE;
    }
    else if (ecomDev) {
        baseUrl = ECOM_DEV_SEARCH_BASE;
    }
    var queryUrl = "".concat(baseUrl).concat(endpoint, "?site=").concat(siteId, "&limit=").concat(source.limit ? source.limit : 6);
    if (ecom || ecomDev) {
        queryUrl += "&projectId=".concat(siteId);
    }
    SxQueryUtils.get(queryUrl, function (data) {
        console.log(data);
        callback(new SuggestionBlock({
            type: source.type,
            data: searchApiResponseToDataSet(data),
            plan: data.plan,
            attribution: data.attribution
        }, source.layout, source.dataPoints, source.categoryStyle, context.pluginConfiguration.suggestions, source.style));
    }, function () {
        callback(createEmptyBlock(context, source));
    }, 'json', false);
};
var loadSource = function (context, suggestionUrl, query, source, callback, skipSuggestions, includeContentGroups, excludeContentGroups) {
    if (skipSuggestions === void 0) { skipSuggestions = false; }
    if (source.type === BlockEntryType.ResultGroup) {
        loadResultGroup(context, suggestionUrl, query, source, function (data) {
            try {
                var retry = context.pluginConfiguration.callbacks.noResultsLoaded !== undefined && data.dataSet.data.length === 0;
                if (retry && context.pluginConfiguration.callbacks.noResultsLoaded(query, SearchContext.SUGGESTIONS, data)) {
                    loadResultGroup(context, suggestionUrl, query, source, callback, skipSuggestions, includeContentGroups, excludeContentGroups);
                }
                else {
                    callback(data);
                }
            }
            catch (err) {
                console.error(err);
                callback(data);
            }
        }, skipSuggestions, includeContentGroups, excludeContentGroups);
    }
    else if (source.type === BlockEntryType.SearchHistory) {
        loadSearchHistory(context, source, callback);
    }
    else if (source.type === BlockEntryType.DataSet) {
        loadDataSet(context, source, callback);
    }
    else if (source.type === BlockEntryType.Empty) {
        var block = createEmptyBlock(context, source);
        block.setEmpty(true);
        callback(block);
    }
    else if (source.type === BlockEntryType.PopularQueries) {
        loadPopularQueries(context, suggestionUrl, source, callback);
    }
    else if (source.type === BlockEntryType.PopularResults) {
        loadPopularResults(context, source, callback);
    }
    else {
        console.warn('Source', source.type, 'not supported yet');
        callback(createEmptyBlock(context, source));
    }
};
export default {
    load: function (context, suggestionUrl, query, sources, callback, includeContentGroups, excludeContentGroups) {
        var blocks = new Array(sources.length);
        var loaded = 0;
        var skipQuerySuggestions = sources.reduce(function (acc, source) { return acc || (source.type === BlockEntryType.ResultGroup && source.value === 'ss360QuerySuggestions'); }, false);
        sources.forEach(function (source, idx) {
            loadSource(context, suggestionUrl, query, source, function (block) {
                blocks[idx] = block;
                loaded++;
                if (loaded === sources.length) {
                    if (context.pluginConfiguration.callbacks.suggestPreRender !== undefined) {
                        try {
                            context.pluginConfiguration.callbacks.suggestPreRender(blocks);
                        }
                        catch (err) {
                            console.error(err);
                        }
                    }
                    callback(blocks);
                }
            }, skipQuerySuggestions && source.value !== 'ss360QuerySuggestions', includeContentGroups, excludeContentGroups);
        });
    }
};
